<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="#325181" title="Impact Business" offset="0">
          <div slot="header-actions">
            <v-btn
              v-if="formOpen"
              :loading="deleting"
              small
              raised
              color="error"
              class="mr-2"
              @click="deleteimpactBusiness()"
              >Delete</v-btn
            >
            <v-btn small raised color="info" @click="toggleForm()">
              {{ formOpen ? "Close" : "Add" }}
            </v-btn>
          </div>
          <v-sheet v-if="formOpen" class="mt-2">
            <v-tabs
              v-model="activeTab"
              color="grey lighten-1"
              dark
              slider-color="black"
            >
              <v-tab ripple>Details</v-tab>
              <v-tab v-if="userData.role.includes('Admin')" ripple>Stats</v-tab>
              <v-spacer />
              <v-btn :loading="saving" color="success" @click="save"
                >Save</v-btn
              >
              <!-- TAB : DETAILS -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-form ref="impactBusinessForm">
                      <v-layout key="form" wrap justify-center>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.company"
                            :rules="[(v) => !!v || 'Company Name is required']"
                          />
                        </v-flex>
                        <v-flex xs12 class="autoMargin">
                          <span class="subheading">Profile Picture</span>
                          <template v-if="formData.id">
                            <div v-if="formData.imageUrl">
                              <v-img
                                :src="formData.imageUrl"
                                :width="300"
                                :height="200"
                                class="autoMargin"
                              />
                              <v-btn
                                small
                                block
                                color="info"
                                @click="changeImage = true"
                                >Change Image</v-btn
                              >
                            </div>
                            <croppa
                              v-if="!formData.imageUrl || changeImage"
                              v-model="image"
                              :show-loading="true"
                              :width="300"
                              :height="200"
                              :quality="2"
                              canvas-color="#FFF"
                              placeholder-color="#000000"
                              placeholder="Choose profile image"
                              style="width:300px"
                              initial-size="contain"
                            />
                            <div
                              v-if="!formData.imageUrl || changeImage"
                              class="caption text-xs-center"
                            >
                              Use scroll wheel to zoom in / out and drag to
                              reposition.
                            </div>
                          </template>
                          <template v-else>
                            <br />Please save impact business before adding a
                            photo
                          </template>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.website"
                            hide-details
                            label="Website"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.description"
                            hint="For Example: A construction company in Canterbury"
                            label="Description with location"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.email"
                            :rules="[(v) => !!v || 'Email is required']"
                            hide-details
                            label="Contact E-mail (not public)"
                            required
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.phone"
                            hide-details
                            label="Contact Phone (not public)"
                          />
                        </v-flex>
                        <v-flex xs12 v-if="userData.role.includes('Admin')">
                          <v-text-field
                            v-model="formData.urlKeyword"
                            hint="Upstreamnz.co.nz/impactBusinessProfile/YOUR_KEYWORD"
                            label="URL Keyword ~ /impactBusinessProfile/keyword"
                          />
                        </v-flex>
                        <v-flex xs12 v-if="userData.role.includes('Admin')">
                          <v-select
                            v-model="formData.status"
                            :items="['Pending', 'Approved', 'Suspended']"
                            label="Status"
                            placeholder="Please select"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            v-model="formData.whoWeAre"
                            label="Who we are"
                            counter="700"
                            maxlength="700"
                            :rules="[
                              (v) =>
                                v.length <= 700 ||
                                'Maximum of 700 characters allowed.',
                            ]"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            v-model="formData.whyWeCare"
                            label="Why we care"
                            counter="700"
                            maxlength="700"
                            :rules="[
                              (v) =>
                                v.length <= 700 ||
                                'Maximum of 700 characters allowed.',
                            ]"
                          />
                        </v-flex>
                        <v-flex xs12 v-if="userData.role.includes('Admin')">
                          <v-textarea
                            v-model="formData.recentImpactStory"
                            label="Most Recent Impact Story"
                            counter="700"
                            maxlength="700"
                            :rules="[
                              (v) =>
                                v.length <= 700 ||
                                'Maximum of 700 characters allowed.',
                            ]"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            v-model="formData.chosenGoodCause"
                            :items="goodCauseName"
                            label="Chosen Good Cause"
                            placeholder="Please select"
                          />
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="userData.role.includes('Admin')">
                <v-card flat>
                  <v-card-text>
                    <v-form ref="impactBusinessForm">
                      <v-layout key="form" wrap justify-center>
                        <v-flex v-if="userData.role.includes('Admin')" xs12>
                          <strong>Front page Stats Settings</strong>
                        </v-flex>
                        <v-flex v-if="userData.role.includes('Admin')" xs12>
                          <v-checkbox
                            v-model="formData.buyerSelected"
                            label="Is a Buyer"
                          />
                        </v-flex>
                        <!-- Buyer Section -->
                        <v-flex
                          v-if="
                            userData.role.includes('Admin') &&
                              formData.buyerSelected
                          "
                          xs6
                        >
                          <v-text-field
                            v-model="formData.impactBusinessSupliers"
                            hide-details
                            label="Impact Business Suppliers"
                            required
                          />
                        </v-flex>
                        <v-flex
                          v-if="
                            userData.role.includes('Admin') &&
                              formData.buyerSelected
                          "
                        >
                          <v-text-field
                            v-model="formData.buyersSlogan"
                            hide-details
                            label="Message for Stat 1"
                            counter="110"
                            maxlength="110"
                            :rules="[
                              (v) =>
                                v.length <= 100 ||
                                'Maximum of 110 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex
                          v-if="
                            userData.role.includes('Admin') &&
                              formData.buyerSelected
                          "
                          xs6
                        >
                          <v-text-field
                            v-model="formData.contributionsGenerated"
                            hide-details
                            label="Contributions We have Generated"
                            required
                          />
                        </v-flex>
                        <v-flex
                          v-if="
                            userData.role.includes('Admin') &&
                              formData.buyerSelected
                          "
                        >
                          <v-text-field
                            v-model="formData.contributionsGeneratedSlogan"
                            hide-details
                            label="Message for Stat 2"
                            counter="110"
                            maxlength="110"
                            :rules="[
                              (v) =>
                                v.length <= 100 ||
                                'Maximum of 110 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          v-if="
                            userData.role.includes('Admin') &&
                              formData.buyerSelected
                          "
                        >
                          <v-textarea
                            v-model="formData.communityHoursSlogan"
                            hide-details
                            label="Slogan for Community Hours Stat"
                            counter="100"
                            maxlength="100"
                            :rules="[
                              (v) =>
                                v.length <= 100 ||
                                'Maximum of 100 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>
                        <!-- Buyer Section End -->
                        <!-- Tradies Section -->
                        <v-flex v-if="userData.role.includes('Admin')" xs12>
                          <v-checkbox
                            v-model="formData.tradiesSelected"
                            label="Tradies information"
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          v-if="
                            formData.tradiesSelected &&
                              userData.role.includes('Admin')
                          "
                        >
                          <v-textarea
                            v-model="formData.tradieSlogan"
                            hide-details
                            label="Slogan under Badge"
                            counter="100"
                            maxlength="100"
                            :rules="[
                              (v) =>
                                v.length <= 100 ||
                                'Maximum of 100 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex
                          xs6
                          v-if="
                            formData.tradiesSelected &&
                              userData.role.includes('Admin')
                          "
                        >
                          <v-text-field
                            v-model="formData.tradieStat1"
                            hide-details
                            label="First Stat"
                            counter="55"
                            maxlength="55"
                            :rules="[
                              (v) =>
                                v.length <= 55 ||
                                'Maximum of 55 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex
                          xs6
                          v-if="
                            formData.tradiesSelected &&
                              userData.role.includes('Admin')
                          "
                        >
                          <v-text-field
                            v-model="formData.tradieMessage1"
                            hide-details
                            label="Message for Stat 1"
                            counter="110"
                            maxlength="110"
                            :rules="[
                              (v) =>
                                v.length <= 100 ||
                                'Maximum of 110 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex
                          xs6
                          v-if="
                            formData.tradiesSelected &&
                              userData.role.includes('Admin')
                          "
                        >
                          <v-text-field
                            v-model="formData.tradieStat2"
                            hide-details
                            label="Second Stat"
                            counter="55"
                            maxlength="55"
                            :rules="[
                              (v) =>
                                v.length <= 55 ||
                                'Maximum of 55 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex
                          xs6
                          v-if="
                            formData.tradiesSelected &&
                              userData.role.includes('Admin')
                          "
                        >
                          <v-text-field
                            v-model="formData.tradieMessage2"
                            hide-details
                            label="Message for Stat 2"
                            counter="110"
                            maxlength="110"
                            :rules="[
                              (v) =>
                                v.length <= 110 ||
                                'Maximum of 110 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>

                        <!-- Tradies Section End -->
                        <!-- Suppliers Section -->
                        <v-flex v-if="userData.role.includes('Admin')" xs12>
                          <v-checkbox
                            v-model="formData.supplierSelected"
                            label="Is a Supplier"
                          />
                        </v-flex>
                        <v-flex
                          v-if="
                            userData.role.includes('Admin') &&
                              formData.supplierSelected
                          "
                          xs6
                        >
                          <v-text-field
                            v-model="formData.impactBusinessSales"
                            hide-details
                            label="Impact Business Sales"
                            required
                          />
                        </v-flex>
                        <v-flex
                          v-if="
                            userData.role.includes('Admin') &&
                              formData.supplierSelected
                          "
                        >
                          <v-text-field
                            v-model="formData.suppliersSlogan"
                            hide-details
                            label="Message for Stat 1"
                            counter="110"
                            maxlength="110"
                            :rules="[
                              (v) =>
                                v.length <= 100 ||
                                'Maximum of 110 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex
                          v-if="
                            userData.role.includes('Admin') &&
                              formData.supplierSelected
                          "
                          xs6
                        >
                          <v-text-field
                            v-model="formData.contributionsGeneratedSupplier"
                            hide-details
                            label="Contributions We have Generated"
                            required
                          />
                        </v-flex>
                        <v-flex
                          v-if="
                            userData.role.includes('Admin') &&
                              formData.supplierSelected
                          "
                        >
                          <v-text-field
                            v-model="
                              formData.contributionsGeneratedSloganSupplier
                            "
                            hide-details
                            label="Message for Stat 2"
                            counter="110"
                            maxlength="110"
                            :rules="[
                              (v) =>
                                v.length <= 100 ||
                                'Maximum of 110 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          v-if="
                            userData.role.includes('Admin') &&
                              formData.supplierSelected
                          "
                        >
                          <v-textarea
                            v-model="formData.communityHoursSloganSupplier"
                            hide-details
                            label="Slogan for Community Hours Stat"
                            counter="100"
                            maxlength="100"
                            :rules="[
                              (v) =>
                                v.length <= 100 ||
                                'Maximum of 100 characters allowed.',
                            ]"
                            required
                          />
                        </v-flex>
                        <!-- Suppliers Section End -->
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
            <v-layout row class="pl-3 pr-3">
              <v-btn
                v-if="formData.status === 'Approved'"
                @click="downloadCertificate"
                >Download Certificate</v-btn
              >
              <v-btn
                v-if="activeTab != 3"
                :loading="saving"
                color="success"
                @click="save"
                >Save</v-btn
              >
            </v-layout>
          </v-sheet>
          <v-data-table
            v-else
            key="list"
            :headers="headers"
            :items="impactBusinesses"
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                style="color: #4cc7e8"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.company }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.website }}</td>
              <td>{{ item.phone }}</td>
              <td class="action-col" width="20">
                <v-btn flat icon @click="open(item)">
                  <v-icon color="blue">mdi-folder-outline</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    imageOrientation: "Landscape",
    impactStoryDialog: false,
    image: null,
    changeImage: false,
    activeTab: null,
    saving: false,
    deleting: false,
    formOpen: false,
    formData: {},
    headers: [
      {
        sortable: true,
        text: "Name",
        value: "company",
      },
      {
        sortable: true,
        text: "Status",
        value: "status",
      },
      {
        sortable: true,
        text: "Email",
        value: "email",
      },
      {
        sortable: true,
        text: "Website",
        value: "website",
      },
      {
        sortable: true,
        text: "Phone",
        value: "phone",
      },
      {
        sortable: false,
        text: "",
        value: "action",
      },
    ],
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      impactBusinesses: "impactBusinesses/list",
      goodCauses: "goodCauses/approved",
    }),
    goodCauseName: function() {
      let names = [];
      this.goodCauses.forEach((goodCause) => {
        names.push(goodCause.name);
      });
      return names;
    },
  },
  mounted() {
    this.$store.dispatch("impactBusinesses/loadAllAdmin");
    this.$store.dispatch("goodCauses/loadAll");
  },
  methods: {
    toggleForm() {
      if (!this.formOpen) {
        this.formData = {};
      }
      this.formOpen = !this.formOpen;
    },
    created() {
      this.$nextTick(function() {
        this.$store.dispatch("impactBusinesses/loadAllAdmin");
      });
    },
    mounted() {
      this.$store.dispatch("impactBusinesses/loadAll");
      this.$store.dispatch("goodCauses/loadAll");
    },
    open(business) {
      this.image = null;
      this.saving = false;
      this.formData = business;
      this.formOpen = true;
    },
    save() {
      this.saving = true;
      if (this.image && this.image.imageSet) {
        this.image.generateBlob(
          (blob) => {
            this.formData.image = { file: blob };
            this.$store
              .dispatch("impactBusinesses/save", this.formData)
              .then((business) => {
                this.formData = business;
                this.changeImage = false;
                this.saving = false;
              });
          },
          "image/jpeg",
          0.9
        );
      } else {
        this.$store
          .dispatch("impactBusinesses/save", this.formData)
          .then((business) => {
            this.formData = business;
            this.saving = false;
          });
      }
    },
    downloadCertificate() {
      window.open(
        `https://upstreamnz.live.simplesoftware.nz/impactBusiness/pdf/${this.formData.id}`,
        "_blank",
        "location=no"
      );
    },
    deleteimpactBusiness() {
      this.$confirm(
        "Are you sure you want to delete this impact business?"
      ).then((res) => {
        if (res) {
          this.deleting = true;
          this.$store
            .dispatch("impactBusinesses/delete", this.formData.id)
            .then((res) => {
              this.formOpen = false;
              this.deleting = false;
            });
        }
      });
    },
    deleteImpactStory(impactStory) {},
  },
};
</script>

<style>
.croppa-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.icon-remove {
  position: absolute;
  top: 5px !important;
  right: -35px !important;
}

.croppa-container canvas {
  border: 1px solid;
}
</style>
